import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from "moment-timezone";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { includes } from "lodash";
function RegularzationApproval() {
  const [employeeData, setemployeeData] = useState([]);
  const { HRreqularzation, MangerApproval, AccessData } = useUserDetails();
  const navigate = useNavigate();
  const [display, setdisplay] = useState(false);
  const locatdatas = JSON.parse(sessionStorage.getItem("user"));
  let Roledata = JSON.parse(sessionStorage.getItem("RegApp"));
  console.log(Roledata, "Roledata");

  const [Alldata, setAlldata] = useState("");

  const [ID, setID] = useState("");
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const getInitData = async (id) => {
    const query = `query regularizationRequestById($id: String!){ 

  getRegularizationById(id: $id){ 

    data { 

      id 

      checkIn 

      checkOut 

      reason 

      status 

      teamleaderId 

      teamApproval 

      hrApproval 

      user{ 

        id 

        firstName 

        lastName 

        email 

      } 

      approvalStatus { 

        id 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

        status 

      } 

    } 

    success 

    error 

    message 

  } 

} `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id: +id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const regularizationRowdata =
        response.data.data.getRegularizationById?.data?.[0];
      setAlldata(regularizationRowdata);
      const weekoffRowdata = response.data.data.getRegularizationById?.data[0];
      setemployeeData(weekoffRowdata);
      console.log(regularizationRowdata, "regularizationRowdata");

      if (
        (Roledata == "Hr" || Roledata == "HR") &&
        regularizationRowdata.teamApproval === "approved" &&
        regularizationRowdata.hrApproval === "pending"
      ) {
        setdisplay(true);
      }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const checkInTime = moment(employeeData?.checkIn)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");
  const checkOutTime = moment(employeeData?.checkOut)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;

    if (employeeData?.approvalStatus !== null) {
      query = `
        mutation regularizationManagerApproval(
          $id: ID!,
          $status: String!,
          $approverId: ID!,
          $screenName: String!
        ) {
          regularizationApprovalManager(
            id: $id,
            status: $status,
            approverId: $approverId,
            screenName: $screenName
          ) {
            RegularizationApprovalManager {
              checkIn
              checkOut
              reason
              teamleaderId
              status
              teamApproval
              user {
                id
              }
            }
            message
            success
            error
          }
        }
      `;

      variables = {
        id: +ID,
        status: statusdata,
        approverId: locatdatas?.id,
        screenName: "Regularization Approval",
      };
    } else {
      // HR approval
      query = `
        mutation HRApprovalRegularization($input: RegularizationApprovalHRInput!) {
          regularizationApprovalHR(input: $input) {
            regularizationApprovalHR {
              id
              status
              hrApproval
            }
            message
            success
            error
          }
        }
      `;

      variables = {
        input: {
          id: +ID,
          status: statusdata,
        },
      };
    }

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setConfirmationDialog((prev) => ({
        ...prev,
        open: false,
      }));

      const isHRSuccess =
        response.data.data?.regularizationApproval?.regularizationApprovalHR !==
        null;
      const isManagerSuccess =
        response.data.data?.regularizationApprovalManager
          ?.RegularizationApprovalManager !== null;

      if (isHRSuccess || isManagerSuccess) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/regularization-request");
      } else {
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while submitting. Please try again later.",
      });
    }
  };

  const handleclose = () => {
    navigate("/regularization-request");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
        {/* Card Title */}
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              textAlign="center"
              gutterBottom
            >
              Regularization Details
            </Typography>
          }
        />

        {/* Leave Details Content */}
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>

                <Typography variant="h6">
                  <strong> Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {/* {employeeData?.status} */}
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Check In:</strong>{" "}
                  <span style={{ color: "#67748E" }}>{checkInTime}</span>
                </Typography>
                <Typography variant="h6">
                  <strong>Check Out:</strong>{" "}
                  <span style={{ color: "#67748E" }}>{checkOutTime}</span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {(employeeData?.approvalStatus?.approver?.id == locatdatas?.id ||
              display) && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}

            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default RegularzationApproval;
